import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-408bc96b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = { class: "card_text_and_image_wrapper" }
const _hoisted_3 = { class: "custom-list" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Reslängd:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Tågpass:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Bokningar:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Logistik:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Vinprovningar:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Alsace (Strasbourg & Colmar)"),
  /*#__PURE__*/_createElementVNode("li", null, "Bourgogne (Dijon & Beaune)"),
  /*#__PURE__*/_createElementVNode("li", null, "Rhône (Châteauneuf-du-Pape och Lyon)"),
  /*#__PURE__*/_createElementVNode("li", null, "Provence (Toulon & Vidauban)"),
  /*#__PURE__*/_createElementVNode("li", null, "Bordeaux (Staden Bordeaux, Medoc och Saint-Émilion)"),
  /*#__PURE__*/_createElementVNode("li", null, "Loire (Tours och Chinon)"),
  /*#__PURE__*/_createElementVNode("li", null, "Paris"),
  /*#__PURE__*/_createElementVNode("li", null, "Champagne (Reims & Épernay)")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/artiklar/cykla-i-europa" }, "ta med cykel i Europa", -1))
const _hoisted_12 = { class: "custom-list" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Varför besöka?", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Rekommenderad bas:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Vingårdar att besöka:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Att göra:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Mat & dryck:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Ta sig runt", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "http://www.velodocteurs.com/" }, "Colmar Cycling - Vélodocteurs", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://www.levelolibre.fr/" }, "The Free Bike", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Vingårdar i Alsace", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { class: "custom-list" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Varför besöka?", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Rekommenderad bas:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Vingårdar att besöka:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Att göra:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Mat & dryck:", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Ta sig runt", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://location-velo-beaune.notresphere.com/" }, "Bourgogne Randonnées location vélo électrique Beaune", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Vingårdar i Bourgogne", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = { class: "custom-list" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Varför besöka?", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Rekommenderad bas:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Vingårdar att besöka:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Att göra:", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Mat & dryck:", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Ta sig runt", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://orangebike.fr/" }, "Orange bike", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Vingårdar i Châteauneuf-du-Pape", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = { class: "custom-list" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Varför besöka?", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Rekommenderad bas:", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Vingårdar att besöka:", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Att göra:", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Mat & dryck:", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Ta sig runt", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Vingårdar i Provence", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_68 = { class: "custom-list" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Varför besöka?", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Rekommenderad bas:", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Vingårdar att besöka:", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Att göra:", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Mat & dryck:", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_75 = { class: "custom-list" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Varför besöka?", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Rekommenderad bas:", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Vingårdar att besöka:", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Att göra:", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Mat & dryck:", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Ta sig runt", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Vingårdar i Loire", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_91 = { class: "custom-list" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Varför besöka?", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Rekommenderad bas:", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Vingårdar att besöka:", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Att göra:", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Mat & dryck:", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/guider/paris-frankrike" }, "Guide till Paris", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_99 = { class: "custom-list" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Varför besöka?", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Rekommenderad bas:", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Vingårdar att besöka:", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Att göra:", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Mat & dryck:", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Vi har nu kommit till Le Grand Finale längs denna vinresa genom Frankrike, nämligen Champagne. Känt för sin exklusiva dryck med toner av bröd, är Champagne den vinregion som längst producerat mousserande vin och använder sig av \"Champagne-metoden\" i sin tillverkning. Vi kan inte annat än rekommendera er att ta tid att lära känna historien, processen och vinet när ni väl är på besök. ", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Champagne-distriktet är orienterat runt orterna Reims och Épernay, vilka båda lämpar sig att övernatta i. Vi kommer att ge ett förslag på visit som utgår från Épernay. ", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Ta sig runt. Man kan antingen köra bil eller cykla mellan gårdarna. Det må vara vanligare att åka bil, men då kommer dessvärre inte alla kunna smaka på vinet vid varje vingård. Vi skulle därför rekommendera er att cykla. Champagne har ett böljande landskap, men vägarna går oftast genom dalarna och man kan därför klara sig utan elcykel. Cykel både med och utan el-stöd finns att hyra vid Épernay's turistbyrå. Hör av er på förhand och boka cyklar, så de inte riskerar att vara uppbokade. ", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Vingårdarna i Champage är mycket gästvänliga. De större husen arrangerar strukturerade turer och provningar, men oavsett storlek är du välkommen in att prova vinet och prata med personalen. Ju mindre vingård, desto mer personligt. Vi rekommenderar att besöka något av de stora husen för en organsierad rundtur, men att i övrigt besöka de mindre gårdarna. De mindre gårdarna låter dig komma nära produktionen och ofta prova viner gratis. Det finns naturligtvis en förhoppning om att du som besökare ska köpa med dig vin, om det smakar. Av den anledningen är det bra att ha bil, men vi rekommenderar att spara lite plats i väskorna inför detta besök och säkerställa att cyklarna har cykelväska. ", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Vingårdar i Champagne:", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Vi har satt samman en tur som går att genomföra under en dag, både med cykel och bil. Om man önskar hålla ett lugnare tempo går rutten att dela upp i två dagar. Vi har satt samman en resplan som tar dig genom hjärtat av Champagne, där du kan utforska familjeägda vingårdar, lära dig om champagneproduktion och njuta av lokala delikatesser. Du kan smidigt ta dig mellan stoppen med cykel eller bil och uppleva regionens charm i din egen takt. Turen går att genomföra under en dag, men för den som önskar hålla ett lugnare tempo går rutten naturligtvis att dela upp över flera dagar. ", -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref } from "vue"; // Ensure this import is present
import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import CustomPic from "../../generics/CustomPic.vue";
import trainIcon from "../../../assets/SVG/trainIcon.vue";
import restaurantIcon from "../../../assets/SVG/restaurantIcon.vue";
import meta from "@/data/meta.json";
import "leaflet/dist/leaflet.css";
import DateRangeIcon from "@/assets/SVG/DateRangeIcon.vue";
import TrainTicketIcon from "@/assets/SVG/trainTicketIcon.vue";
import locationIcon from "@/assets/SVG/locationIcon.vue";
import BookingIcon from "@/assets/SVG/bookingIcon.vue";
import WineIcon from "@/assets/SVG/wineIcon.vue";
import QuestionMark from "@/assets/SVG/questionMark.vue";
import ToDoIcon from "@/assets/SVG/toDoIcon.vue";
import QuestionMarkIcon from "@/assets/SVG/questionMarkIcon.vue";
import MapComponent from "../../generics/MapComponent.vue";
import Breadcrumbs from "@/components/generics/BreadCrumbs.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WineFranceGuide',
  setup(__props) {

const locations = ref([
	{
		id: 1,
		name: "Alsace (Strasbourg & Colmar)",
		country: "Frankrike",
		lat: 48.07582833549854,
		lon: 7.357322440626196,
		link: "#alsace",
	},
	{
		id: 2,
		name: "Bourgogne (Dijon & Beaune)",
		country: "Frankrike",
		lat: 47.322,
		lon: 5.0415,
		link: "#bourgogne",
	},
	{
		id: 3,
		name: "Rhône (Châteauneuf-du-Pape & Lyon)",
		country: "Frankrike",
		lat: 44.05600944547393,
		lon: 4.833848992296051,
		link: "#rhone",
	},
	{
		id: 4,
		name: "Provence (Toulon & Vidauban)",
		country: "Frankrike",
		lat: 43.42627607857844,
		lon: 6.430021145169462,
		link: "#provence",
	},
	{
		id: 5,
		name: "Bordeaux (Staden och Medoc, Saint-Émilion)",
		country: "Frankrike",
		lat: 44.8378,
		lon: -0.5792,
		link: "#bordeaux",
	},
	{
		id: 6,
		name: "Loire (Tours och Chinon)",
		country: "Frankrike",
		lat: 47.3941,
		lon: 0.6848,
		link: "#loire",
	},
	{
		id: 7,
		name: "Paris",
		country: "Frankrike",
		lat: 48.8566,
		lon: 2.3522,
		link: "#paris",
	},
	{
		id: 8,
		name: "Champagne (Reims & Épernay)",
		country: "Frankrike",
		lat: 49.2583,
		lon: 4.0317,
		link: "#champagne",
	},
]);

const champagneVineyards = ref([
	{
		id: 1,
		name: "Gaston Chiquet",
		town: "Dizy",
		lat: 49.06846519073113,
		lon: 3.965252758240512,
		link: "http://www.gastonchiquet.com/",
		text: "Dagen inleds med ett besök hos Gaston Chiquet, en familjeägd vingård med över åtta generationers historia. Här får du en inblick i hur de skapar sina eleganta champagner från egna odlingar, med en särskild betoning på Pinot Meunier. En provning i deras rustika källare låter dig uppleva husets karaktäristiska stil.",
	},
	{
		id: 2,
		name: "Pressoria",
		town: "Ay",
		lat: 49.05696027416394,
		lon: 3.998989500979022,
		link: "http://pressoria.com/",
		text: "Nästa stopp är Pressoria, ett interaktivt museum beläget i ett gammalt presseri i Aÿ. Här får du en sensorisk upplevelse där du kan se, lukta och smaka på champagne på ett helt nytt sätt. Utställningarna tar dig genom områdets unika terroir, druvornas resa och den fascinerande processen bakom varje bubblande flaska. Perfekt för dig som grotta ner dig i vad Champagne är.",
	},
	{
		id: 3,
		name: "Champion Roland",
		town: "Chouilly",
		lat: 49.02542991768207,
		lon: 4.013943303670642,
		link: "https://champagne-roland-champion.com/",
		text: "Därefter besöker vi Champion Roland, en charmig liten vingård där passionen för champagne genomsyrar varje steg i tillverkningen. Roland Champion och hans familj producerar utsökta Grand Cru-champagner i Chouilly, med en särskild förkärlek för Chardonnay. Här kan du prova deras mest kända cuvéer i familjens vardagsrum och få en personlig rundvisning i källaren.",
	},
	{
		id: 4,
		name: "Brasserie de Saint Martin (Lunch)",
		town: "Chouilly",
		lat: 49.025188907837155,
		lon: 4.012947929453434,
		link: null,
		text: "Dags för en välförtjänt lunch på Brasserie de Saint Martin, en mysig restaurang där du kan njuta av franska klassiker med en modern touch. Här rekommenderas särskilt deras rätter med lokala råvaror, såsom en krämig osttallrik från regionen eller en saftig entrecôte med hemlagad bearnaisesås - självklart med ett glas champagne till.",
	},
	{
		id: 5,
		name: "Champagne Pierre Gimonnet et Fils",
		town: "Cuis",
		lat: 48.99878220926288,
		lon: 3.9663940709823646,
		link: "http://www.champagne-gimonnet.com/",
		text: "Efter lunchen väntar ett besök hos Pierre Gimonnet et Fils, en ikonisk producent med ett arv av elegant, mineraldriven Blanc de Blancs. Deras vingårdar i Côte des Blancs är kända för sina kalkrika jordar som ger champagnerna en unik friskhet. Här får du en exklusiv provning där du kan jämföra olika årgångar och upptäcka vad som gör deras cuvéer så speciella.",
	},
	{
		id: 6,
		name: "Avenue de Champagne",
		town: "Épernay",
		lat: 49.042962420407015,
		lon: 3.9608095834098096,
		link: null,
		text: "Dagen avslutas längs den världsberömda Avenue de Champagne i Épernay, där några av de mest prestigefyllda champagnehusen har sina huvudkontor. Promenera eller cykla längs den historiska gatan, njut av arkitekturen och kanske avsluta med ett glas på en av de öppna terrasserna. Besök Moët & Chandon, Perrier-Jouët eller Pol Roger för en sista smak av Champagne-regionens stolthet.",
	},
]);

const alsaceVineyards = ref([
	{
		id: 1,
		name: "Domaine Weinbach",
		town: "Kaysersberg",
		lat: 48.141778,
		lon: 7.260406,
		link: "https://www.domaineweinbach.com/",
		text: "Dagen inleds med ett besök hos Domaine Weinbach, en av Alsaces mest prestigefyllda producenter. Denna biodynamiska vingård i Kaysersberg har anor från 1600-talet och producerar eleganta viner med djup och komplexitet. Här kan du prova deras hyllade Riesling och Gewurztraminer, medan du njuter av utsikten över sluttningarna.",
	},
	{
		id: 2,
		name: "Hugel & Fils",
		town: "Riquewihr",
		lat: 48.167011,
		lon: 7.296939,
		link: "https://m.hugel.com/",
		text: "Nästa stopp är den sagolika byn Riquewihr, en av de mest välbevarade längs vinvägen. Här kan du promenera genom smala gränder, besöka lokala butiker och självklart prova vin. Vi rekommenderar ett besök hos Hugel & Fils, en anrik producent känd för sina torra Rieslingviner med lång lagringspotential.",
	},
	{
		id: 3,
		name: "Ribeauvillé (Lunch)",
		town: "Ribeauvillé",
		lat: 48.195158,
		lon: 7.31745,
		link: null,
		text: "Lunch intas i den charmiga byn Ribeauvillé, där du kan njuta av klassiska Alsace-rätter. Prova en mustig choucroute garnie (surkål med korv och fläsk) eller en tarte flambée, Alsaces svar på pizza.",
	},
	{
		id: 4,
		name: "Domaine Trimbach",
		town: "Ribeauvillé",
		lat: 48.196659,
		lon: 7.314097,
		link: "https://www.trimbach.fr/",
		text: "Efter lunch besöker vi Domaine Trimbach i Ribeauvillé, en av Alsaces mest respekterade vinproducenter. Trimbach har skapat förstklassiga viner i nästan 400 år och är särskilt kända för sin ikoniska Riesling Cuvée Frédéric Emile. En provning här är ett måste för Riesling-älskaren.",
	},
	{
		id: 5,
		name: "Haut-Koenigsbourg",
		town: "Orschwiller",
		lat: 48.249286,
		lon: 7.344833,
		link: "https://www.haut-koenigsbourg.fr/",
		text: "Avsluta dagen med ett besök på det imponerande slottet Haut-Koenigsbourg, som tronar högt över vinfälten. Slottet erbjuder en fascinerande inblick i Alsaces historia och bjuder på en spektakulär utsikt över regionen.",
	},
]);
const bourgogneVineyards = ref([
	{
		id: 1,
		name: "Domaine Yves Boyer-Martenot",
		town: "Meursault",
		lat: 46.9789,
		lon: 4.7651,
		link: "http://www.boyer-martenot.com/",
		text: "En familjeägd vingård i hjärtat av Meursault, känd för sina eleganta och lagringsdugliga vita viner. Här får du en personlig vinprovning i en autentisk miljö.",
	},
	{
		id: 2,
		name: "Domaines Famille Picard",
		town: "Pommard",
		lat: 46.937023768805496,
		lon: 4.735679725255919,
		link: "http://www.famillepicard.fr/",
		text: "Domaines Famille Picard äger flera egendomar i Bourgogne och producerar både röda och vita viner av hög kvalitet. Här erbjuds guidade provningar i deras historiska källare.",
	},
	{
		id: 3,
		name: "Château de Pommard",
		town: "Pommard",
		lat: 47.0033,
		lon: 4.7925,
		link: "https://www.chateaudepommard.com/",
		text: "Dags för lunch på det berömda Château de Pommard, där du kan avnjuta lokala specialiteter i en vacker slottsmiljö. Här får du även möjlighet att prova deras biodynamiska viner och lära dig om terroiren i Côte de Beaune.",
	},
	{
		id: 4,
		name: "Domaine Bouchard Père & Fils",
		town: "Beaune",
		lat: 47.0246,
		lon: 4.8375,
		link: "https://www.bouchard-pereetfils.com/",
		text: "Efter lunch beger vi oss till Beaune och besöker en av regionens äldsta vinproducenter. Här erbjuds en exklusiv provning i deras historiska källare, där du kan smaka på både unga och lagrade Bourgogne-viner.",
	},
	{
		id: 5,
		name: "Clos de Vougeot",
		town: "Vougeot",
		lat: 47.1734,
		lon: 4.9501,
		link: "https://www.closdevougeot.fr/",
		text: "Ett historiskt stopp på din resa! Clos de Vougeot är ett imponerande kloster och vingård från medeltiden, grundat av cisterciensermunkarna. Här får du en fascinerande inblick i Bourgognes vinproduktion genom tiderna. Vingården ligger en bit bort, men åker du med ett obegränsat interrailkort rekommenderar vi att ta cykeln på tåget till och från Vougeot. Guidade turer på engelska sker 11:30 och 15:30.",
	},
	{
		id: 6,
		name: "Hôtel-Dieu (Hospices de Beaune)",
		town: "Beaune",
		lat: 47.0239,
		lon: 4.837,
		link: "https://hospices-de-beaune.com/",
		text: "Innan dagen avrundas tar vi en avstickare till Beaunes ikoniska sjukhus och museum, Hôtel-Dieu. Byggnaden är känd för sin färgglada takarkitektur och sin rika vinauktionshistoria.",
	},
	{
		id: 7,
		name: "Rue de Lorraine, Beaune",
		town: "Beaune",
		lat: 47.0222,
		lon: 4.8389,
		link: null,
		text: "Avsluta dagen med en promenad genom Beaunes charmiga gamla stad. Slå dig ner på en lokal bistro och njut av en klassisk Boeuf Bourguignon eller en osttallrik med Epoisses och Comté, ackompanjerat av ett glas elegant Pinot Noir.",
	},
]);
//chateauneufVineyards
const rhoneVineyards = ref([
	{
		id: 1,
		name: "Domaine de Cristia",
		town: "Châteauneuf-du-Pape",
		lat: 44.0809,
		lon: 4.8583,
		link: "https://www.cristia.com/",
		text: "Dagen börjar med ett besök på Domaine de Cristia, en familjeägd vingård som producerar både traditionella och moderna Châteauneuf-du-Pape-viner. Här får du prova eleganta Grenache-dominerade viner med en tydlig terroirprägel.",
	},
	{
		id: 2,
		name: "Château de Beaucastel",
		town: "Châteauneuf-du-Pape",
		lat: 44.0725,
		lon: 4.8314,
		link: "https://www.beaucastel.com/",
		text: "Ett av de mest berömda vinhusen i regionen, Château de Beaucastel, är känd för sina biodynamiskt odlade viner och sin imponerande historia. Här får du en guidad tur genom vingårdarna och en djupgående vinprovning.",
	},
	{
		id: 3,
		name: "Le Verger des Papes (Lunch)",
		town: "Châteauneuf-du-Pape",
		lat: 44.0575,
		lon: 4.831,
		link: "https://vergerdespapes.com/",
		text: "För lunch rekommenderar vi Le Verger des Papes, en restaurang med fantastisk utsikt över vingårdarna. Här kan du njuta av lokala specialiteter som lamm med örter, ratatouille och en ostbricka ackompanjerad av ett glas Châteauneuf-du-Pape.",
	},
	{
		id: 4,
		name: "Domaine de Beaurenard - Paul Coulon & Fils",
		town: "Châteauneuf-du-Pape",
		lat: 44.05359133841021,
		lon: 4.834505690722797,
		link: "http://www.beaurenard.fr/",
		text: "Efter lunch fortsätter vi till Domaine de Beaurenard, en historisk producent med rötter från 1600-talet. Här får du prova ett brett utbud av viner, inklusive deras prestigefyllda cuvéer.",
	},
	{
		id: 5,
		name: "Château Des Fines Roches",
		town: "Châteauneuf-du-Pape",
		lat: 44.050264040245146,
		lon: 4.849061295646685,
		link: "https://www.domainesmousset.com/fr/147-domaine-cave-chateauneuf-du-pape",
		text: "Vårt nästa stopp är Château Des Fines Roches, ett charmigt vinslott som erbjuder provningar i en spektakulär miljö. Deras eleganta och välbalanserade viner speglar den klassiska Châteauneuf-du-Pape-stilen.",
	},
	{
		id: 6,
		name: "Clos du Calvaire",
		town: "Châteauneuf-du-Pape",
		lat: 44.0326,
		lon: 4.8587,
		link: "https://www.clos-du-calvaire.fr/",
		text: "Dagen avslutas med en avslappnad provning hos Clos du Calvaire, en mindre familjedriven vingård där du får ett varmt välkomnande och en chans att prova autentiska och välgjorda viner.",
	},
]);
const provenceVineyards = ref([
	{
		id: 1,
		name: "Château de Saint Martin",
		town: "Taradeau",
		lat: 43.444253688416225,
		lon: 6.4330554904000685,
		link: "https://www.chateaudesaintmartin.com/",
		text: "Resan startar på Château de Saint Martin, en av de äldsta stora vingårdarna i Provence. Här kan du bo i deras charmiga gästhus och hyra cyklar för att utforska regionens vingårdar.",
	},
	{
		id: 2,
		name: "Château les Crostes",
		town: "Lorgues",
		lat: 43.44567365013211,
		lon: 6.379377030837671,
		link: "https://chateau-les-crostes.com/",
		text: "Första stoppet är Château les Crostes, en vacker vingård där du kan njuta av en guidad provning av deras eleganta roséviner.",
	},
	{
		id: 3,
		name: "Lunch på Restaurant Le Vallon",
		town: "Le Thoronet",
		lat: 43.452868993377834,
		lon: 6.300042890831295,
		link: "https://www.restaurant-levallon.com/",
		text: "Dags för en smakfull lunch på Restaurant Le Vallon, där du kan avnjuta lokala provensalska rätter i en avslappnad miljö.",
	},
	{
		id: 4,
		name: "Abbaye du Thoronet",
		town: "Le Thoronet",
		lat: 43.46044199576398,
		lon: 6.263831197856193,
		link: "https://www.lethoronet.fr/",
		text: "Innan vi återgår till vingårdarna besöker det historiska cistercienserklostret Abbaye du Thoronet, känt för sin arkitektur och akustik.",
	},
	{
		id: 5,
		name: "Château Sainte Croix",
		town: "Carcès",
		lat: 43.477354844129835,
		lon: 6.224895733818457,
		link: "https://www.chateau-sainte-croix.com/",
		text: "Dagens sista vingårdsbesök är på Château Sainte Croix, en familjeägd vingård som producerar klassiska Provence-roséviner. Efter en dag full av vinprovningar och natursköna vyer återvänder vi till Château de Saint Martin för en avkopplande kväll.",
	},
]);

/*
const provenceVineyards = ref([
{
		id: 1,
		name: "Chateau de Saint Martin",
		town: "Taradeau",
		lat: 43.4943,
		lon: 6.3534,
		link: "https://www.chateauberne.com/",
		text: "Resan startar på Château de Berne, en vingård och hotell där du kan bo bekvämt och hyra cyklar för att utforska regionens vingårdar.",
	},{
		id: 1,
		name: "Château de Berne",
		town: "Lorgues",
		lat: 43.4943,
		lon: 6.3534,
		link: "https://www.chateauberne.com/",
		text: "Resan startar på Château de Berne, en vingård och hotell där du kan bo bekvämt och hyra cyklar för att utforska regionens vingårdar.",
	},
	{
		id: 2,
		name: "Château les Crostes",
		town: "Vidauban",
		lat: 43.4255,
		lon: 6.4337,
		link: "https://www.lescrostes.com/",
		text: "Första stoppet är Château les Crostes, en vacker vingård där du kan njuta av en guidad provning av deras eleganta roséviner.",
	},
	{
		id: 3,
		name: "Abbaye du Thoronet",
		town: "Le Thoronet",
		lat: 43.4704,
		lon: 6.2291,
		link: "https://www.lethoronet.fr/",
		text: "Efter vinprovningen tar vi en paus från vingårdarna och besöker det historiska cistercienserklostret Abbaye du Thoronet, känt för sin arkitektur och akustik.",
	},
	{
		id: 4,
		name: "Lunch på Restaurant Le Vallon",
		town: "Le Thoronet",
		lat: 43.4709,
		lon: 6.2325,
		link: "https://www.restaurant-levallon.com/",
		text: "Dags för en smakfull lunch på Restaurant Le Vallon, där du kan avnjuta lokala provensalska rätter i en avslappnad miljö.",
	},
	{
		id: 5,
		name: "Château Sainte Croix",
		town: "Carcès",
		lat: 43.4742,
		lon: 6.1768,
		link: "https://www.chateau-sainte-croix.com/",
		text: "Dagens sista vingårdsbesök är på Château Sainte Croix, en familjeägd vingård som producerar klassiska Provence-roséviner. Efter en dag full av vinprovningar och natursköna vyer återvänder vi till Château de Berne för en avkopplande kväll.",
	},
]);*/
/*
const provenceVineyards = ref([
	{
		id: 1,
		name: "Domaine Tempier",
		town: "Le Castellet (Bandol)",
		lat: 43.1906,
		lon: 5.7928,
		link: "https://www.domainetempier.com/",
		text: "Nästa stopp är Domaine Tempier i Bandol, en av de mest respekterade producenterna i regionen. Här får du prova kraftfulla, lagringsdugliga Mourvèdre-viner och lära dig om den unika terroiren i Bandol.",
	},
	{
		id: 2,
		name: "Lunch i Le Castellet",
		town: "Le Castellet",
		lat: 43.1961,
		lon: 5.7808,
		link: null,
		text: "Lunch på en charmig bistro i den medeltida byn Le Castellet. Prova en klassisk Ratatouille eller en grillad lammkotlett med lokala örter.",
	},
	{
		id: 3,
		name: "Clos Sainte Magdeleine",
		town: "Cassis",
		lat: 43.2121,
		lon: 5.5316,
		link: "https://www.clossaintemagdeleine.fr/",
		text: "På eftermiddagen beger vi oss till den pittoreska kuststaden Cassis och besöker Clos Sainte Magdeleine. Denna vingård ligger spektakulärt vid havet och producerar några av Frankrikes bästa vita viner.",
	},
	{
		id: 4,
		name: "Calanques de Cassis",
		town: "Cassis",
		lat: 43.2148,
		lon: 5.502,
		link: "https://www.calanques-parcnational.fr/",
		text: "Dagen avslutas med en båttur eller vandring i de dramatiska Calanques-klipporna vid Cassis. Avnjut en aperitif vid vattnet innan du återvänder till din utgångspunkt.",
	},
]);*/
const bordeauxVineyards = ref([
	{
		id: 1,
		name: "Château Margaux",
		town: "Margaux",
		lat: 45.0413,
		lon: -0.6769,
		link: "https://www.chateau-margaux.com/",
		text: "Dagen inleds med ett besök på det legendariska Château Margaux, en av de mest prestigefyllda producenterna i Bordeaux. Här får du en guidad tur genom de historiska vinkällarna och en exklusiv provning av deras utsökta viner.",
	},
	{
		id: 2,
		name: "Château Pichon Baron",
		town: "Pauillac",
		lat: 45.1866,
		lon: -0.7462,
		link: "https://www.pichonbaron.com/",
		text: "Nästa stopp är Château Pichon Baron, ett sagolikt slott i Pauillac. Vinerna här är djupa och strukturerade, med klassisk Bordeaux-karaktär. En provning här ger en inblick i regionens terroir och vinmakningsfilosofi.",
	},
	{
		id: 3,
		name: "Lunch i Pauillac",
		town: "Pauillac",
		lat: 45.192,
		lon: -0.7511,
		link: null,
		text: "Lunch på en charmig restaurang vid Gironde-floden. Här rekommenderas en klassisk Entrecôte à la Bordelaise, serverad med en kraftig röd Bordeaux.",
	},
	{
		id: 4,
		name: "Château Smith Haut Lafitte",
		town: "Pessac-Léognan",
		lat: 44.7276,
		lon: -0.5959,
		link: "https://www.smith-haut-lafitte.com/",
		text: "Efter lunch beger vi oss söderut till Château Smith Haut Lafitte, en ikonisk producent känd för sina eleganta röda och vita viner. Gården erbjuder även en konstupplevelse med sina skulpturer utspridda i vingårdarna.",
	},
	{
		id: 5,
		name: "Cité du Vin",
		town: "Bordeaux",
		lat: 44.8571,
		lon: -0.5505,
		link: "https://www.laciteduvin.com/",
		text: "Dagen avslutas i Bordeaux stad med ett besök på Cité du Vin, ett interaktivt vinmuseum där du kan fördjupa dig i vinets värld. Avsluta kvällen med ett glas Bordeaux vid floden.",
	},
]);
/*const loireVineyards = ref([
	{
		id: 1,
		name: "Domaine Huet",
		town: "Vouvray",
		lat: 47.4133,
		lon: 0.7861,
		link: "https://www.domainehuet.com/",
		text: "Dagen inleds i Vouvray med ett besök hos Domaine Huet, en ikonisk producent känd för sina biodynamiska Chenin Blanc-viner. Här får du en djupgående provning av allt från torra till söta och mousserande viner.",
	},
	{
		id: 2,
		name: "Château de Minière",
		town: "Bourgueil",
		lat: 47.2776,
		lon: 0.1782,
		link: "https://www.chateaudeminiere.com/",
		text: "Nästa stopp är Château de Minière i Bourgueil, där Cabernet Franc är kungen. Slottet kombinerar tradition med hållbar vinproduktion och erbjuder en provning i en autentisk slottsmiljö.",
	},
	{
		id: 3,
		name: "Lunch i Saumur",
		town: "Saumur",
		lat: 47.2597,
		lon: -0.0781,
		link: null,
		text: "Lunch i Saumur vid Loirefloden. Prova en klassisk Rillettes de Tours, en lokal paté som passar perfekt med en lätt och fruktig Saumur-Champigny.",
	},
	{
		id: 4,
		name: "Bouvet-Ladubay",
		town: "Saumur",
		lat: 47.2651,
		lon: -0.0806,
		link: "https://www.bouvet-ladubay.fr/",
		text: "Efter lunch beger vi oss till Bouvet-Ladubay, en av Loiredalens mest kända mousserande vinproducenter. Deras källare sträcker sig över flera kilometer och erbjuder en imponerande guidad tur med provning av deras Crémant de Loire.",
	},
	{
		id: 5,
		name: "Château de Chenonceau",
		town: "Chenonceaux",
		lat: 47.3241,
		lon: 1.0703,
		link: "https://www.chenonceau.com/",
		text: "Dagen avslutas med ett besök på Château de Chenonceau, ett av Loiredalens mest ikoniska slott. Här kan du promenera genom dess eleganta trädgårdar och njuta av en sista smak av Loiredalens magi.",
	},
]);*/
const loireVineyards = ref([
	{
		id: 1,
		name: "Château de Beaulieu",
		town: "Saumur",
		lat: 47.2711,
		lon: -0.0761,
		link: "https://www.chateaudebeaulieu49.fr/",
		text: "Resan startar på Château de Beaulieu, en charmig vingård med boende strax utanför Saumur. Här får du en första inblick i Loiredalens viner och möjlighet att hyra en cykel för dagens utflykt.",
	},
	{
		id: 2,
		name: "Domaine des Roches Neuves",
		town: "Varrains",
		lat: 47.2367,
		lon: -0.0794,
		link: "https://www.rochesneuves.com/",
		text: "Första stoppet är Domaine des Roches Neuves i Varrains, en ledande biodynamisk producent av Saumur-Champigny. Här får du prova eleganta och strukturerade Cabernet Franc-viner.",
	},
	{
		id: 3,
		name: "Lunch på Le Pot de Lapin",
		town: "Saumur",
		lat: 47.2612,
		lon: -0.0736,
		link: "https://www.lepotdelapin.fr/",
		text: "Tillbaka i Saumur är det dags för lunch på den populära bistron Le Pot de Lapin. Här serveras rustika lokala rätter med ett utmärkt urval av Loireviner.",
	},
	{
		id: 4,
		name: "Langlois-Chateau",
		town: "Saint-Hilaire-Saint-Florent",
		lat: 47.2599,
		lon: -0.1093,
		link: "https://www.langlois-chateau.fr/",
		text: "Efter lunch besöker vi Langlois-Chateau, en av de främsta producenterna av Crémant de Loire. Följ med på en guidad tur i deras underjordiska källare och smaka deras eleganta mousserande viner.",
	},
	{
		id: 5,
		name: "Château de Brézé",
		town: "Brézé",
		lat: 47.1839,
		lon: -0.0483,
		link: "https://www.chateaudebreze.com/",
		text: "Dagen avslutas på Château de Brézé, ett unikt slott med en imponerande underjordisk vinkällare. Här kan du smaka på vita och röda Saumur-viner innan du cyklar tillbaka till Saumur för en avkopplande kväll.",
	},
]);

const parisHighlights = ref([
	{
		id: 1,
		name: "Eiffeltornet",
		lat: 48.8588443,
		lon: 2.2943506,
		link: "https://www.toureiffel.paris/en",
		text: "Inget besök i Paris är komplett utan ett stopp vid Eiffeltornet. Detta ikoniska monument erbjuder en fantastisk utsikt över staden och är en symbol för Paris.",
	},
	{
		id: 2,
		name: "Musée d'Orsay",
		lat: 48.86,
		lon: 2.325,
		link: "https://www.musee-orsay.fr/en",
		text: "Musée d'Orsay är hem till en av världens bästa samlingar av impressionistisk och post-impressionistisk konst, med verk av Monet, Van Gogh och Degas.",
	},
	{
		id: 3,
		name: "Louvre",
		lat: 48.8606111,
		lon: 2.337644,
		link: "https://www.louvre.fr/en",
		text: "Världens största och mest besökta museum. Hem till oersättliga konstverk som Mona Lisa och Venus de Milo.",
	},
	{
		id: 4,
		name: "Notre-Dame de Paris",
		lat: 48.8529682,
		lon: 2.3499021,
		link: "https://www.notredamedeparis.fr/en/",
		text: "Den gotiska katedralen är ett måste för alla som vill uppleva både religiös historia och fantastisk arkitektur.",
	},
	{
		id: 5,
		name: "Montmartre & Sacré-Cœur",
		lat: 48.8867,
		lon: 2.3431,
		link: "https://www.sacre-coeur-montmartre.com/en/",
		text: "Montmartre är en historisk och konstnärlig stadsdel med små gator och charmiga caféer. Den berömda Basilikan Sacré-Cœur ger en fantastisk vy över Paris.",
	},
	{
		id: 6,
		name: "Champs-Élysées och Triumfbågen",
		lat: 48.8738,
		lon: 2.295,
		link: "https://www.parisinfo.com/museum-monument/71444/Arc-de-Triomphe",
		text: "Promenera längs den berömda avenyn Champs-Élysées och avsluta vid den majestätiska Triumfbågen, ett symboliskt monument för Frankrike.",
	},
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).wineFranceGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Vinresa i Frankrike med Tåg",
      backgroundImageClass: "background-bike"
    }),
    _createVNode(ContentWrapper, { showBreadcrumbs: true }, {
      default: _withCtx(() => [
        _createVNode(Breadcrumbs),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextBlock, {
            "header-tag": "h2",
            header: "\n            Att upptäcka Frankrikes fantastiska vindistrikt med tåg är en dröm för vinälskare och resenärer som vill kombinera kultur, gastronomi och natursköna upplevelser. Med ett välutvecklat järnvägsnät och smidiga förbindelser mellan landets mest kända vinregioner, är detta en resa som både är bekväm och inspirerande."
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(MapComponent, {
              locations: locations.value,
              color: "blue"
            }, null, 8, ["locations"])
          ]),
          _createVNode(TextBlock, { header: "Planering och praktisk information" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_3, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(DateRangeIcon))),
                  _hoisted_4,
                  _createTextVNode(" 2-3 veckor rekommenderas för att hinna uppleva flera av de större vinregionerna. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(TrainTicketIcon))),
                  _hoisted_5,
                  _createTextVNode(" För denna resan rekommenderar vi interrailkort på 15 dagar på 2 månader. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(BookingIcon))),
                  _hoisted_6,
                  _createTextVNode(" Vissa tåg, särskilt snabbtågen (TGV), kräver platsreservation. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(trainIcon))),
                  _hoisted_7,
                  _createTextVNode(" In- och utresa till och från Frankrike görs med fördel genom Strasbourg. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(WineIcon))),
                  _hoisted_8,
                  _createTextVNode(" De flesta vingårdar kräver förbokning av besök och provningar. ")
                ])
              ]),
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Reseupplägg och rekommenderad rutt" }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(TextBlock, {
            "header-tag": "h2",
            header: "Vinregioner och detaljerade reseplaner"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" I denna sektion går vi igenom de olika regionerna och ger förslag på resmål i regionen. Vi förklarar vad man bör se, göra, äta och dricka i regionerna. Vi ger också förslag på hur man tar sig mellan vingårdarna. Att köra bil mellan vingårdarna leder till att alla inte kan dricka vin. Därför förespråkar vi att cykla mellan vingårdarna och med elcyklar behöver det inte vara betyngande. Det finns ofta ställen att hyra cyklar lokal, men att ta med din egen cykel på resan är också görbart. För mer information, läs vår guide om att "),
              _hoisted_11,
              _createTextVNode(". ")
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/alsace-frankrike.jpg",
            id: "alsace"
          }),
          _createVNode(TextBlock, { header: "Alsace - Blommiga viner och sagolika byar" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_12, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(QuestionMarkIcon))),
                  _hoisted_13,
                  _createTextVNode(" Känt för torra vita viner och pittoreska byar. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(trainIcon))),
                  _hoisted_14,
                  _createTextVNode(" Strasbourg eller Colmar. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(WineIcon))),
                  _hoisted_15,
                  _createTextVNode(" Domaine Weinbach, Trimbach, Hugel & Fils. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(ToDoIcon))),
                  _hoisted_16,
                  _createTextVNode(" Utforska vinrutten Route des Vins d'Alsace. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_17,
                  _createTextVNode(" Flammkuchen, choucroute och lokala Riesling-viner. ")
                ])
              ]),
              _createTextVNode(" Vi inleder vår resa i Alsace, en vinregion där fransk och tysk kultur möts. Här dominerar vita druvor som Riesling, Gewurztraminer och Pinot Gris, och vinvägen Route des Vins de Alsace slingrar sig genom charmiga småstäder och vingårdar. Oavsett hur du tar dig runt i området, bjuder regionen på fantastiska vyer och spännande smaker. "),
              _hoisted_18,
              _hoisted_19,
              _createTextVNode(" Strasbourg och Colmar är de bästa utgångspunkterna för din resa. Strasbourg är en livlig stad med imponerande arkitektur, medan Colmar bjuder på sagolika gränder och en intim atmosfär. Colmar är känd för sina korsvirkeshus, dess kanalområde kallat \"Lilla Venedig\" och känns som taget ur den lilla staden i \"Skönheten och odjuret\". "),
              _hoisted_20,
              _createTextVNode(" Både bil och cykel är möjliga färdmedel för att färdas mellan vingårdar och städer på landsbygden, men Alsace är en vinregion med mer kuperad terräng än andra. Om du väljer att cykla, se till att boka en elcykel för att enkelt ta dig mellan vingårdarna. "),
              _hoisted_21,
              _hoisted_22,
              _createTextVNode("Hos "),
              _hoisted_23,
              _createTextVNode(", beläget vid stadens tågstation går det att hyra cykel till ett mycket överkomligt pris. Enda nackdelen är att deras utbud vad gäller elcykel är bristande. Hos "),
              _hoisted_24,
              _createTextVNode(" är priserna dessvärre inte så gratis, men där finns å andra sidan gott om elcyklar. "),
              _hoisted_25,
              _createTextVNode(" Vi har satt ihop en resplan för en dagsutflykt genom Alsaces vinlandskap. Om du vill ta det lugnare kan rutten delas upp över två dagar. "),
              _createVNode(MapComponent, {
                locations: alsaceVineyards.value,
                color: "blue"
              }, null, 8, ["locations"]),
              _createElementVNode("ol", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alsaceVineyards.value, (vineyard) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: vineyard.id
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(vineyard.name), 1),
                    _createTextVNode(),
                    _hoisted_26,
                    _createTextVNode(" " + _toDisplayString(vineyard.text), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/Domaines-Famille-Picard.jpg",
            id: "bourgogne"
          }),
          _createVNode(TextBlock, { header: "Bourgogne - Pinot Noir och Chardonnay i världsklass" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_27, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(QuestionMarkIcon))),
                  _hoisted_28,
                  _createTextVNode(" En av de mest ansedda vinregionerna i världen. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(locationIcon))),
                  _hoisted_29,
                  _createTextVNode(" Dijon eller Beaune. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(WineIcon))),
                  _hoisted_30,
                  _createTextVNode(" Domaine de la Romanée-Conti, Louis Jadot. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(ToDoIcon))),
                  _hoisted_31,
                  _createTextVNode(" Vinprovning i Hospices de Beaune, cykla genom vinfälten. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_32,
                  _createTextVNode(" Boeuf Bourguignon och ost som Epoisses. ")
                ])
              ]),
              _createTextVNode(" Vi fortsätter resan till Bourgogne – en av världens mest prestigefyllda vinregioner. Här, i hjärtat av Frankrike, produceras några av de mest eftertraktade vinerna, där särskilt Pinot Noir och Chardonnay når sin fulla potential. Bourgognes vintradition sträcker sig över tusen år, och de små familjeägda vingårdarna i regionen arbetar ofta enligt hantverksmässiga metoder som förts vidare genom generationer. Landskapet är en mosaik av böljande vinfält, historiska kloster och charmiga byar där tiden verkar stå stilla. "),
              _hoisted_33,
              _hoisted_34,
              _createTextVNode(" Städer lämpliga att utgå ifrån är antingen Dijon eller Beaune. Dijon, Bourgognes huvudstad, bjuder på en elegant blandning av historisk arkitektur, kulinariska upplevelser och en livlig marknad där du kan prova lokala delikatesser. Beaune, å andra sidan, är en mer intim stad känd för sitt vinhus Hôtel-Dieu och sina vinkällare, där du kan utforska århundraden av vinproduktion under jord. Båda städerna har goda förbindelser med tåg och bil, vilket gör dem till perfekta utgångspunkter för en vinresa genom Bourgogne. "),
              _hoisted_35,
              _createTextVNode(" Både bil och cykel är möjliga färdmedel för att färdas mellan vingårdar på landsbygden. Beaune och Dijon ligger längsmed floden Saône som slingrar sig genom landskapet. Med det sagt är landskapet rätt platt i förhållande till andra vindistrikt. Därtill finns det goda cykelvägar och du klarar dig bra på en vanlig cykel. "),
              _hoisted_36,
              _hoisted_37,
              _createTextVNode("Hos "),
              _hoisted_38,
              _createTextVNode(", beläget mellan Beaunes stadskärna och stadens tågstation går det att hyra cykel till ett överkomligt pris. "),
              _hoisted_39,
              _createTextVNode(" Vi har satt ihop en resplan för en dagsutflykt genom Bourgognes vinlandskap. Om du vill ta det lugnare kan rutten delas upp över två dagar. Turen tar dig genom Côte d’Or, Bourgognes främsta vinregion, och kombinerar ikoniska vingårdar, historiska platser och utmärkta matupplevelser. Turen kan göras med bil eller cykel för den som vill njuta av de natursköna omgivningarna. "),
              _createVNode(MapComponent, {
                locations: bourgogneVineyards.value,
                color: "blue"
              }, null, 8, ["locations"]),
              _createElementVNode("ol", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bourgogneVineyards.value, (vineyard) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: vineyard.id
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(vineyard.name), 1),
                    _createTextVNode(),
                    _hoisted_40,
                    _createTextVNode(" " + _toDisplayString(vineyard.text), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/Château-des-Fines-Roches-Chateau-neuf-de-Pape.jpg",
            id: "rhone"
          }),
          _createVNode(TextBlock, { header: "Rhône - Mustiga viner och gastronomi" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_41, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(QuestionMarkIcon))),
                  _hoisted_42,
                  _createTextVNode(" Kraftfulla röda viner och fantastisk mat. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(locationIcon))),
                  _hoisted_43,
                  _createTextVNode(" Châteauneuf-du-Pape. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(WineIcon))),
                  _hoisted_44,
                  _createTextVNode(" Chapoutier, Guigal. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(ToDoIcon))),
                  _hoisted_45,
                  _createTextVNode(" Vinprovning i området, gastronomiska upplevelser i Lyon. Besök Palais des Papes i Avignon. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_46,
                  _createTextVNode(" Coq au Vin, Lyonnais-korvar Andouillette. ")
                ])
              ]),
              _createTextVNode(" Vi fortsätter vår vinresa till Rhône, där vi rekommenderar ett besök i Châteauneuf-du-Pape, en av regionens mest ikoniska vinbyar. Här, bland solvarma vingårdar och historiska slottsruiner, produceras några av världens mest prestigefyllda viner. "),
              _hoisted_47,
              _createTextVNode(" Det böljande landskapet i Châteauneuf-du-Pape lämpar sig utmärkt för att utforskas med elcykel. Med välanlagda småvägar mellan vingårdarna kan du smidigt ta dig runt och njuta av de natursköna omgivningarna. "),
              _hoisted_48,
              _hoisted_49,
              _createTextVNode(" Vi rekommenderar att bo på Domaine de Cristia, där du kan låna elcyklar för att enkelt ta dig mellan vingårdarna. Alternativt kan du hyra cykel här: "),
              _hoisted_50,
              _createTextVNode(". "),
              _hoisted_51,
              _createTextVNode(" Vi har satt ihop en resplan för en dagsutflykt genom Châteauneuf-du-Papes vinlandskap, där du får möjlighet att besöka några av de mest framstående vingårdarna, njuta av lokala delikatesser och fördjupa dig i regionens rika vintradition. ")
            ]),
            _: 1
          }),
          _createVNode(MapComponent, {
            locations: rhoneVineyards.value,
            color: "blue"
          }, null, 8, ["locations"]),
          _createElementVNode("ol", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rhoneVineyards.value, (vineyard) => {
              return (_openBlock(), _createElementBlock("li", {
                key: vineyard.id
              }, [
                _createElementVNode("strong", null, _toDisplayString(vineyard.name), 1),
                _createTextVNode(),
                _hoisted_52,
                _createTextVNode(" " + _toDisplayString(vineyard.text), 1)
              ]))
            }), 128))
          ]),
          _createVNode(CustomPic, {
            picturePath: "pictures/provence-lavendar-fields.jpeg",
            id: "provence"
          }),
          _createVNode(TextBlock, { header: "Provence - Roséviner och medelhavsatmosfär" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_53, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(QuestionMarkIcon))),
                  _hoisted_54,
                  _createTextVNode(" Roséviner och soliga landskap. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(locationIcon))),
                  _hoisted_55,
                  _createTextVNode(" Toulon eller Vidauban. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(WineIcon))),
                  _hoisted_56,
                  _createTextVNode(" Domaine Tempier, Château de Beaucastel. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(ToDoIcon))),
                  _hoisted_57,
                  _createTextVNode(" Besök de enastående lavendelfälten i Valensole. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_58,
                  _createTextVNode(" Bouillabaisse, Ratatouille. ")
                ])
              ]),
              _createTextVNode(" Vi fortsätter vår vinresa till Provence, en region känd för sina soldränkta landskap, charmiga byar och utsökta roséviner. Här möts du av lavendelfält, olivlundar och vingårdar som sträcker sig mot horisonten. "),
              _hoisted_59,
              _createTextVNode(" Det böljande provensalska landskapet upplevs bäst på två hjul. Med elcykel kan du smidigt ta dig mellan vingårdarna och njuta av den pittoreska naturen i lugn takt. Det finns flera cykeluthyrare i området där du kan hyra en passande cykel för din vistelse. "),
              _hoisted_60,
              _hoisted_61,
              _createTextVNode(" Vi rekommenderar att bo på Château de Saint Martin inte långt från Vidaubans tågstation. Här kan du koppla av i en vacker miljö och få en genuin provensalsk upplevelse. "),
              _hoisted_62,
              _createTextVNode(" Vi har satt ihop en resplan för en dagsutflykt genom Provence vinlandskap, där du får möjlighet att besöka några av regionens mest framstående vingårdar och smaka på dess eleganta viner. "),
              _hoisted_63,
              _hoisted_64,
              _createTextVNode(" Denna rutt tar dig genom några av de mest ikoniska delarna av Provence – från soliga vinfält till dramatiska havsklippor, med stopp vid vingårdar där du kan prova de bästa lokala vinerna och njuta av regionens gastronomi. "),
              _hoisted_65,
              _hoisted_66,
              _createTextVNode(" För att uppleva det bästa av Provence och dess roséviner på cykel, föreslår vi en rutt i området kring Lorgues och Le Thoronet. Denna region är känd för sina pittoreska landskap och framstående vingårdar inom Côtes de Provence. ")
            ]),
            _: 1
          }),
          _createVNode(MapComponent, {
            locations: provenceVineyards.value,
            color: "blue"
          }, null, 8, ["locations"]),
          _createElementVNode("ol", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provenceVineyards.value, (vineyard) => {
              return (_openBlock(), _createElementBlock("li", {
                key: vineyard.id
              }, [
                _createElementVNode("strong", null, _toDisplayString(vineyard.name), 1),
                _createTextVNode(),
                _hoisted_67,
                _createTextVNode(" " + _toDisplayString(vineyard.text), 1)
              ]))
            }), 128))
          ]),
          _createVNode(CustomPic, {
            picturePath: "pictures/wine-tasting-bordeaux.jpg",
            id: "bordeaux"
          }),
          _createVNode(TextBlock, { header: "Bordeaux - Röda viner i världsklass" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_68, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(QuestionMarkIcon))),
                  _hoisted_69,
                  _createTextVNode(" Ikoniska viner och vacker arkitektur. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(locationIcon))),
                  _hoisted_70,
                  _createTextVNode(" Bordeaux stad. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(WineIcon))),
                  _hoisted_71,
                  _createTextVNode(" Château Margaux, Château Mouton Rothschild. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(ToDoIcon))),
                  _hoisted_72,
                  _createTextVNode(" Vinmuseet Cité du Vin, utflykt till Saint-Émilion. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_73,
                  _createTextVNode(" Entrecôte à la Bordelaise och canelés. ")
                ])
              ])
            ]),
            _: 1
          }),
          _createTextVNode(" Denna rutt tar dig genom Médocs prestigefyllda vinlandskap och avslutas i Bordeaux stad. "),
          _createVNode(MapComponent, {
            locations: bordeauxVineyards.value,
            color: "blue"
          }, null, 8, ["locations"]),
          _createElementVNode("ol", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bordeauxVineyards.value, (vineyard) => {
              return (_openBlock(), _createElementBlock("li", {
                key: vineyard.id
              }, [
                _createElementVNode("strong", null, _toDisplayString(vineyard.name), 1),
                _createTextVNode(),
                _hoisted_74,
                _createTextVNode(" " + _toDisplayString(vineyard.text), 1)
              ]))
            }), 128))
          ]),
          _createVNode(CustomPic, {
            picturePath: "pictures/Saumur-Loire.jpg",
            id: "loire"
          }),
          _createVNode(TextBlock, { header: "Loire - Slottsvyer och eleganta viner" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_75, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(QuestionMarkIcon))),
                  _hoisted_76,
                  _createTextVNode(" Känt för sina eleganta vita och mousserande viner. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(locationIcon))),
                  _hoisted_77,
                  _createTextVNode(" Tours, Saumur eller Chinon. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(WineIcon))),
                  _hoisted_78,
                  _createTextVNode(" Domaine Huet, Château de Chambord. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(ToDoIcon))),
                  _hoisted_79,
                  _createTextVNode(" Besök Loire-slotten, vinprovning i Saumur. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_80,
                  _createTextVNode(" Får- och getostar, Tarte Tatin. ")
                ])
              ]),
              _hoisted_81,
              _createTextVNode(" Vi fortsätter vår vinresa till Loire, en region som är berömd för sina eleganta viner, sagolika slott och böljande landskap. Här kan du njuta av några av Frankrikes bästa vita viner, mousserande Crémant de Loire och de karaktärsfulla Cabernet Franc-vinerna. "),
              _hoisted_82,
              _createTextVNode(" Det natursköna Loiredalen upplevs bäst på cykel. Med elcykel kan du enkelt ta dig mellan vingårdarna och följa floden genom vinfälten. Det finns flera cykeluthyrare i området, och vi rekommenderar att hyra cykel i Saumur, där du enkelt kan ta dig ut på vingårdsrutterna. "),
              _hoisted_83,
              _hoisted_84,
              _createTextVNode(" Vi rekommenderar att bo på Château de Beaulieu, en charmig vingård med bed & breakfast strax utanför Saumur. Här får du en autentisk upplevelse av Loiredalen, med vinprovningar och natursköna omgivningar. "),
              _hoisted_85,
              _createTextVNode(" Vi har satt ihop en resplan för en dagsutflykt genom Loiredalens vinlandskap, där du får möjlighet att besöka några av regionens mest framstående vingårdar och smaka på deras unika viner. "),
              _hoisted_86,
              _hoisted_87,
              _createTextVNode(" Denna rutt tar dig genom några av de mest idylliska delarna av Loire – från historiska slott till anrika vingårdar, där du kan njuta av både landskap och vin i världsklass. "),
              _hoisted_88,
              _hoisted_89,
              _createTextVNode(" För att uppleva det bästa av Loire och dess viner på cykel, föreslår vi en rutt i området kring Saumur och Parnay. Denna del av Loire är känd för sina kalkstensgrottor, utmärkta Chenin Blanc och de delikata röda vinerna från Cabernet Franc. Vi rekommenderar också att prova Saumurs renomerade sötvin Quarts de Chaume Grand Cru när du är i området. "),
              _createVNode(MapComponent, {
                locations: loireVineyards.value,
                color: "blue"
              }, null, 8, ["locations"]),
              _createElementVNode("ol", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loireVineyards.value, (vineyard) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: vineyard.id
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(vineyard.name), 1),
                    _createTextVNode(),
                    _hoisted_90,
                    _createTextVNode(" " + _toDisplayString(vineyard.text), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/champs_elysees.jpg",
            id: "paris"
          }),
          _createVNode(TextBlock, { header: "Paris - Kultur, gastronomi och världskända sevärdheter" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_91, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(QuestionMarkIcon))),
                  _hoisted_92,
                  _createTextVNode(" Världens mest romantiska stad, fylld med historia, konst och gastronomi. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(locationIcon))),
                  _hoisted_93,
                  _createTextVNode(" Centrala Paris – Marais, Saint-Germain eller Montmartre. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(WineIcon))),
                  _hoisted_94,
                  _createTextVNode(" Clos Montmartre (Paris), dagsutflykter till Champagne. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(ToDoIcon))),
                  _hoisted_95,
                  _createTextVNode(" Besök Louvren och Eiffeltornet, promenera längs Seine, njut av en klassisk caféupplevelse. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_96,
                  _createTextVNode(" Croissant och café au lait till frukost, boeuf bourguignon till middag, och självklart vin. ")
                ])
              ]),
              _createTextVNode(" Upptäck Paris genom dess ikoniska sevärdheter, kulinariska pärlor och dolda charmiga kvarter. Mer information finns att finna i vår "),
              _hoisted_97,
              _createTextVNode(". "),
              _createVNode(MapComponent, {
                locations: parisHighlights.value,
                color: "blue"
              }, null, 8, ["locations"]),
              _createElementVNode("ol", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parisHighlights.value, (highlight) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: highlight.id
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(highlight.name), 1),
                    _createTextVNode(),
                    _hoisted_98,
                    _createTextVNode(" " + _toDisplayString(highlight.text), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/champagne.jpg",
            id: "champagne"
          }),
          _createVNode(TextBlock, { header: "Champagne - Bubblande avslut på resan" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_99, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(QuestionMarkIcon))),
                  _hoisted_100,
                  _createTextVNode(" Hem till världens mest berömda mousserande vin. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(locationIcon))),
                  _hoisted_101,
                  _createTextVNode(" Reims eller Épernay. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(WineIcon))),
                  _hoisted_102,
                  _createTextVNode(" Moët & Chandon, Veuve Clicquot, Taittinger. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(ToDoIcon))),
                  _hoisted_103,
                  _createTextVNode(" Besök katedralen i Reims, promenera Avenue de Champagne. ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_104,
                  _createTextVNode(" Prova lokala specialiteter som Choucroute de Brienne & Cacasse à Cul Nu. ")
                ])
              ]),
              _hoisted_105,
              _hoisted_106,
              _hoisted_107,
              _hoisted_108,
              _hoisted_109,
              _hoisted_110,
              _createVNode(MapComponent, {
                locations: champagneVineyards.value,
                color: "blue"
              }, null, 8, ["locations"]),
              _createElementVNode("ol", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(champagneVineyards.value, (vineyard) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: vineyard.id
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(vineyard.name), 1),
                    _createTextVNode(),
                    _hoisted_111,
                    _createTextVNode(" " + _toDisplayString(vineyard.text), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(TextBlock, {
            "header-tag": "h2",
            header: "Sammanfattning"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Att tågluffa genom Frankrikes vinregioner är en oförglömlig upplevelse som kombinerar gastronomi, kultur och natursköna miljöer. Genom att planera resan väl, boka provningar i förväg och njuta av varje regions unika atmosfär, kan du skapa en minnesvärd vinresa. Skål och trevlig resa! ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})